import DurationInput from './DurationInput';
import useSettingsForm from './useSettingsForm';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

function SettingsForm({ onSubmit }: { onSubmit?: () => void }) {
  const [state, formAction] = useSettingsForm(onSubmit);
  const { duration, rest, repeats } = state;
  return (
    <form action={formAction} className="flex flex-col gap-6">
      <Label>
        <span className="w-20 text-right">Duration:</span>
        <DurationInput className="w-28 font-mono" key={'d' + duration} name="duration" defaultValue={duration} required />
      </Label>
      <Label>
        <span className="w-20 text-right">Rest:</span>
        <DurationInput className="w-28 font-mono" name="rest" key={'r' + rest} defaultValue={rest} required />
      </Label>
      <Label className="flex-wrap">
        <span className="w-20 text-right">Repeats:</span>
        <Input className="w-28 font-mono" type="number" min={0} name="repeats" key={'x' + repeats} defaultValue={repeats} required />
        <div className="text-xs w-full ms-22 text-muted-foreground">
          Set to 0 for unlimited repeats.
        </div>
      </Label>
      <Button variant="default" type="submit" className="sm:w-40">Save settings</Button>
    </form>
  );
};

export default SettingsForm;
